import { Card } from '@mantine/core';
import { FC, ReactNode } from 'react';

import { cn } from '@/utils/styleUtils.ts';

interface Props {
    children: ReactNode;
    isSelected: boolean;
    onClick: () => void;
    className?: string;
}

const SelectableItem: FC<Props> = ({ children, isSelected, onClick, className }) => {
    return (
        <Card
            onClick={onClick}
            className={cn(
                'relative cursor-pointer select-none rounded-lg border p-4 transition ease-in-out hover:shadow-lg active:translate-y-0.5',
                isSelected ? 'border-green-500 bg-green-100' : 'border-slate-300 bg-white text-slate-700',
                className
            )}
        >
            {children}
        </Card>
    );
};

export default SelectableItem;
